import clsx from 'clsx';
import { ComponentProps } from 'preact';
import { useMemo } from 'preact/hooks';

import { useSelector } from '@/redux/helper';

import { useLiveStreamPlayerContext } from './contexts';

interface LiveStreamPlayerProps extends Omit<ComponentProps<'iframe'>, 'ref' | 'src'> {}

const LiveStreamPlayer = ({ className, ...rest }: LiveStreamPlayerProps) => {
  const userId = useSelector((state) => state.user.userId);
  const playerIframeURL = useSelector((state) => state.remoteConfig.playerIframeURL);
  const { streamId, iframeRef } = useLiveStreamPlayerContext();
  const streamURL = useMemo(() => {
    let url = `${playerIframeURL}?id=${streamId}&playOrder=webrtc,hls`;
    if (userId) {
      url += `&subscriberId=${userId}`;
    }
    return url;
  }, [playerIframeURL, streamId, userId]);

  return (
    <iframe
      className={clsx('preflight preflight-iframe size-full', className)}
      allowFullScreen
      frameBorder="0"
      allow="autoplay; fullscreen; picture-in-picture"
      title="zoolife's live stream player"
      data-hj-allow-iframe
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...rest}
      ref={iframeRef}
      src={streamURL}
    />
  );
};

export default LiveStreamPlayer;
